import Loader from "components/shared/loader";
import { useLocalStorage } from "hooks/useLocalStorage";
import React, { useMemo, useState } from "react";
import CityCell from "./cell";
import Legend from "./legend";
import SearchForm from "./searchForm";
import Table from "./table";

const CityReport = (props) => {
    const [filtersUpdatedAt, setFiltersUpdatedAt] = useState(Date.now());
    const [columnWidths, setColumnWidths] = useLocalStorage("city-planning-column-widths", {});
    const storeColumnWidth = ({ columnWidths: newColumnWidths }) =>
        setColumnWidths({ ...columnWidths, ...newColumnWidths });

    const onFilterChangeWrapper = (func, args) => {
        setFiltersUpdatedAt(Date.now());
        func(...args);
    };

    const countryColumn = {
        Header: "Страна",
        accessor: "country",
        style: {
            whiteSpace: "inherit",
        },
    };

    const tableColumns = useMemo(() => {
        const items = [
            ...(props.params.withCountry ? [countryColumn] : []),
            {
                Header: "Регион",
                accessor: "state",
                style: {
                    whiteSpace: "inherit",
                },
            },
            {
                Header: "Город",
                accessor: "city",
                style: {
                    whiteSpace: "inherit",
                },
                Cell: ({ value, row }) => (
                    <>
                        {value}
                        <span className="text-muted small pl-2">{row.original.timezone}</span>
                    </>
                ),
            },
            ...(props.columns ?? []).slice(1).map((c) => ({
                Header: c.label + (props.counters.carsCount[c.index] ? ` (${props.counters.carsCount[c.index]})` : ""),
                accessor: `${c.index}`,
                style: { overflow: "inherit" },
                columnType: "date",
                isWeekend: c.metadata?.isWeekend,
                Cell: (p) => (
                    <CityCell
                        {...p}
                        history={props.history}
                        roles={props.roles}
                        forwardingEnabled={props.forwardingEnabled}
                        modal={props.modal}
                        refreshData={props.refreshData}
                        params={props.params}
                        enums={props.enums}
                        organization={props.organization}
                        disableCarDropd={props.disableCarDropd}
                        isTour={props.isTour}
                    />
                ),
            })),
        ];
        return items.map((column) => ({
            ...column,
            width: column.width || columnWidths[column.accessor || column.id] || 150,
        }));
    }, [props.counters, props.params]);

    const tableDefaultProps = {
        minRows: 10,
        noDataText: "Нет данных для отображения",
        loadingText: "Загрузка...",
        pageSizeOptions: [30, 50, 100],
    };

    const renderReport = () => {
        const reportProps = {
            storeColumnWidth,
            filtersUpdatedAt,
            data: props.filteredItems,
            columns: tableColumns,
            byPlanDate: props.params.byPlanDate,
            sortBy: props.sortBy,
            sorted: props.sorted,
            forwardingEnabled: props.forwardingEnabled,
            withoutPagination: props.withoutPagination,
        };

        return (
            <div className="list__body-wrap">
                <div className="list__body pb-3 d-flex flex-column">
                    <Table {...tableDefaultProps} {...reportProps} />
                </div>
            </div>
        );
    };

    const compProps = {
        ...props,
        setMultipleValue: (...args) => onFilterChangeWrapper(props.setMultipleValue, args),
        setParam: (...args) => onFilterChangeWrapper(props.setParam, args),
        setValue: (...args) => onFilterChangeWrapper(props.setValue, args),
        resetFilters: (...args) => onFilterChangeWrapper(props.resetFilters, args),
    };

    return (
        <>
            {props.isLoading && (
                <div className="loader-snippet--disable-loader">
                    <Loader />
                </div>
            )}
            <div className="mb-2">
                <SearchForm {...compProps} />
            </div>
            <Legend {...compProps} />
            {renderReport()}
        </>
    );
};

export default CityReport;
